import React from 'react';
import { withApollo } from 'react-apollo';
import SelectReasonModal from './SelectReasonModal';
import { CreateClaimClose } from '../../mutations/CreateClaimClose';

const CloseClaimModal = ({
  client,
  claimId,
  onClaimClosed,
  crmState,
  ...props
}) => {
  const handleClose = (reason, description) => {
    if(!reason) return null;
    client
      .mutate({
        mutation: CreateClaimClose,
        variables: {
          input: {
            claimId,
            reason,
            description
          }
        }
      })
      .then(() => {
        if (onClaimClosed) {
          onClaimClosed();
        }
      }).catch((error) => {return null});
  };

  let closeClaimReasons = [
    { value: 'no_answer', text: 'No answer' },
    { value: 'not_elligible', text: 'Passenger not eligible' },
    { value: 'abandon_requested', text: 'Request for abandon' },
    {
      value: 'extraoridinary_circumstances',
      text: 'Extraordinary circumstances'
    }
  ];

  if (crmState) {
    if (crmState.charAt(0) === 'b') {
      closeClaimReasons = closeClaimReasons.concat([{ value: 'won', text: 'Won' }]);
    }
    if (crmState.charAt(0) === 'a') {
      closeClaimReasons = closeClaimReasons.concat([{ value: 'duplicate', text: 'Duplicate' }]);
    }
  }

  return (
    <SelectReasonModal
      {...props}
      crmState={crmState}
      operation="close claim"
      options={closeClaimReasons}
      handleClose={handleClose}
      isDescriptionVisible
    />
  );
};

export default withApollo(CloseClaimModal);



// WEBPACK FOOTER //
// ./src/component/modals/CloseClaimModal.js